const PIXEL_ID = '1545009850674181'

let initialized = false

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

function safeFbq(...args: any[]) {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq(...args)
    }
  } catch {
    // Swallow errors — pixel must never break the page
  }
}

function loadPixel() {
  try {
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = !0
      t.src = v
      // Silently swallow script load failures (ad blockers, CSP, network errors)
      t.onerror = () => {
        /* noop */
      }
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    safeFbq('init', PIXEL_ID)
    safeFbq('track', 'PageView')
  } catch {
    // If anything goes wrong setting up the pixel, never let it crash the app
  }
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Defer pixel loading until after first paint so it never blocks the critical render path.
  const idle = (window as any).requestIdleCallback
  if (typeof idle === 'function') {
    idle(loadPixel, { timeout: 3000 })
  } else {
    setTimeout(loadPixel, 1500)
  }
}

export function trackInitiateCheckout(variant: 'fq' | 'megapack') {
  const value = variant === 'megapack' ? 27990 : 18990
  const contentName =
    variant === 'megapack' ? 'MegaPack Ciencias 360' : 'Físico-Química Pack'
  safeFbq('track', 'InitiateCheckout', {
    content_name: contentName,
    content_category: 'digital_product',
    currency: 'ARS',
    value,
  })
}

export function trackLead() {
  safeFbq('track', 'Lead')
}
